import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useMemo } from 'react';

import { EditLocationButton } from 'contacts/components';
import { ContactGroupType } from 'contacts/enums';
import { Color, Direction, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  contactGroupType: ContactGroupType;
  isGlobal?: boolean;
}

export const ActionsCell = ({ api, data, contactGroupType, isGlobal }: IProps) => {
  const isEditable = useMemo(() => {
    if (!data) {
      return false;
    }

    // Location is editable if it doesn't have an AR number (for customers)
    if (contactGroupType === ContactGroupType.CUSTOMER) {
      return !data.accountsReceivableId;
    }

    // Location is editable if it doesn't have an AP number (for vendors)
    if (contactGroupType === ContactGroupType.VENDOR) {
      return !data.accountsPayableId;
    }

    return true;
  }, [data, contactGroupType]);

  if (!data) {
    return null;
  }

  const onUpdateLocationSuccess = () => {
    if (isGlobal) {
      api.refreshServerSide();
    }
  };

  return (
    <Stack direction={Direction.ROW} gap={1}>
      {isEditable && (
        <EditLocationButton
          location={data}
          contactGroupType={contactGroupType}
          onSubmitSuccess={onUpdateLocationSuccess}
          buttonElement={
            <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
              <PencilSimpleLine />
            </Typography>
          }
        />
      )}
    </Stack>
  );
};
